import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-medium",
  "use": "icon-medium-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-medium\"><path d=\"M682.666667 85.333333v85.333334h-42.666667v138.368a341.333333 341.333333 0 0 0 31.402667 143.018666l182.656 395.776A64 64 0 0 1 795.946667 938.666667H228.010667a64 64 0 0 1-58.112-90.837334l182.656-395.776A341.333333 341.333333 0 0 0 384 309.034667V170.666667H341.333333V85.333333h341.333334z m-128 85.333334h-85.333334v170.666666h85.333334V170.666667z\" fill=\"#000000\" p-id=\"30045\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol